import { Button } from "@mui/material";
import styled from 'styled-components';

export const ProductCategoryGroupButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;
    
export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 14px;
        padding-right: 14px;
        display: flex;
        gap: 6px;
        font-size: 14px;
        height: 36px;
        border-radius: 5px;
    }
`;